export default [
  {
    path: '/leadership/list',
    name: 'leadership-list',
    component: () => import('@/views/leadership/index.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Our Leadership',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Our Leadership', active: true }
      ],
      roles: 'admin'
    }
  },
  {
    path: '/leadership/add',
    name: 'create-leadership',
    component: () => import('@/views/leadership/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Add Leadership',
      parent: 'leadershipList',
      breadcrumb: [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Our Leadership', url: '/leadership/list' },
        { title: 'Add Leadership', active: true }
      ],
      roles: 'admin'
    }
  },
  {
    path: '/leadership/:id/edit',
    name: 'edit-leadership',
    component: () => import('@/views/leadership/action.vue'),
    meta: {
      allowAnonymous: false,
      pageTitle: 'Edit Leadership',
      parent: 'leadershipList',
      roles: 'admin'
    }
  }
]
